import * as types from './types'
import moment from 'moment'

export default {
  [types.SET_DATE](state, data) {
    if (data.name === 'start') {
      state.startDate = data.value
    } else {
      state.endDate = data.value
    }
  },
  [types.SET_VIEW](state, data) {
    switch (data.name) {
      case 'analyze':
        state.analyzeView = parseInt(data.value)
        break
      case 'range':
        state.rangeView = parseInt(data.value)
        break
      case 'firm':
        state.invoiceFirm = parseInt(data.value)
        break
      default:
        break
    }
  },
  [types.SET_TECHDATA](state, data) {
    state.techData = data
  },
  [types.SET_DATA](state, data) {
    let foundTech = null
    switch (data.name) {
      case 'commission':
        foundTech = state.payroll.find(x => parseInt(x.contact) === parseInt(data.contact))
        if (foundTech) {
          let foundRequest = foundTech.assignments.find(
            x => parseInt(x.calibrateEvent) === parseInt(data.calibrateEvent)
          )
          if (foundRequest) {
            foundRequest.isChanged = true
            foundRequest.commissionOverride = parseFloat(data.amount)
            foundRequest.commission = parseFloat(data.amount)
            let total = 0
            foundTech.assignments.forEach(assignment => {
              total += parseFloat(assignment.commission)
            })
            foundTech.commission = total
            // force refresh
            foundRequest.services = [...foundRequest.services]
          }
        }
        break
      case 'original':
        foundTech = state.payroll.find(x => parseInt(x.contact) === parseInt(data.contact))
        if (foundTech) {
          let foundRequest = foundTech.assignments.find(
            x => parseInt(x.calibrateEvent) === parseInt(data.calibrateEvent)
          )
          if (foundRequest) {
            foundRequest.originalCommission = parseFloat(data.amount)
            // force refresh
            foundRequest.services = [...foundRequest.services]
          }
        }
        break
    }
  },
  [types.SET_DASHBOARD](state, data) {
    state.dashboard = data
  },
  [types.SET_DASHBOARD_BREAKOUT](state, data) {
    state.dashboardBreakout = data
  },
  [types.SET_DASHBOARD_TOP3](state, data) {
    state.dashboardTop3 = data
  },
  [types.SET_DASHBOARD_TOP](state, data) {
    state.dashboardTop = data
  },
  [types.SET_DASHBOARD_PROFIT](state, data) {
    state.dashboardProfit = data
  },
  [types.SET_DASHBOARD_CYCLETIMES](state, data) {
    state.dashboardCycleTimes = data
  },
  [types.SET_DASHBOARD_TREND](state, data) {
    state.dashboardTrend = data
  },
  [types.SET_PAYMENTS](state, data) {
    state.payments = []
    if (data) {
      if (data !== '') {
        state.payments = data
      }
    }
    console.log('Got Payments - before Total', state.payments)
    if (state.payments.length > 0) {
      state.payments.forEach(payment => {
        payment.total = 0
        if (payment.services) {
          payment.services.forEach(element => {
            payment.total += parseFloat(element.rate)
            element.rate = element.rate.toFixed(2)
          })
          payment.total = payment.total.toFixed(2)
        }
      })
    }
    console.log('Got Payments - after Total', state.payments)
  },
  [types.SET_PAYROLL](state, data) {
    state.payroll = []
    if (data) {
      if (data !== '') {
        state.payroll = data
      }
    }
    if (state.payroll.length > 0) {
      state.payroll.forEach(tech => {
        tech.hours = 0
        tech.commission = 0
        tech.sales = 0
        if (tech.assignments !== null) {
          tech.assignments.forEach(assignment => {
            assignment.isChanged = false
            assignment.hours = 0
            assignment.sales = 0
            assignment.commission = 0
            assignment.originalCommission = null
            if (assignment.started !== null && assignment.completed !== null) {
              let duration = moment.duration(
                moment(assignment.completed).diff(moment(assignment.started))
              )
              assignment.hours = duration.asHours()
            }
            if (assignment.services) {
              assignment.services.forEach(service => {
                service.commissionRate = 0
                service.amount = 0
                if (service.rate) {
                  service.rate = parseFloat(service.rate).toFixed(2)
                } else {
                  service.rate = 0
                }
                if (tech.commissionRates) {
                  let found = tech.commissionRates.find(
                    x =>
                      parseInt(x.calibrateServiceGroup) === parseInt(service.calibrateServiceGroup)
                  )
                  if (found) {
                    if (found.commission != null) {
                      service.commissionRate = (parseFloat(found.commission) / 100).toFixed(1)
                      service.amount = (
                        (parseFloat(found.commission) / 100) *
                        parseFloat(service.rate)
                      ).toFixed(2)
                    }
                  }
                }
                assignment.sales += parseFloat(service.rate)
                tech.sales += parseFloat(service.rate)
                assignment.commission += parseFloat(service.amount)
              })
              if (assignment.commissionOverride !== null) {
                assignment.commission = assignment.commissionOverride
                assignment.originalCommission = assignment.commissionOverride
              }
            }
            tech.hours += parseFloat(assignment.hours)
            tech.commission += parseFloat(assignment.commission)
          })
        }
      })
    }
    console.log('Got Payroll Data', state.payroll)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutations.js